import { Box, Stack } from "@mui/material";
import type { FC } from "react";
import { useGetDashboardPermissionsQuery } from "web_myplann/Api/Calculators/useGetDashboardPermissionsQuery";
import { DashboardSectionHeader } from "web_myplann/Dashboard/Components/DashboardSectionHeader";
import { QuickCalculatorTile } from "web_myplann/Dashboard/Components/QuickCalculatorTile";
import { QUICK_CALCULATORS } from "web_myplann/Dashboard/Components/quickCalculators";
import { useOpenCalculator } from "web_myplann/Dashboard/Hooks/useOpenCalculator";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { HorizontalScrollContainer } from "web_myplann/Shared/Components/HorizontalScrollContainer";
import { useHorizontalDragScroll } from "web_myplann/Shared/Hooks/useHorizontalDragScroll";

const PageResources = Resources.Dashboard.QuickCalculators;

export const QuickCalculatorsSection: FC = () => {
	const { t } = useResource();
	const { data: permissions } = useGetDashboardPermissionsQuery();
	const { scrollRef, onMouseDown, wasDragged } = useHorizontalDragScroll();
	const { openCalculator, isOpeningCalculator } = useOpenCalculator();

	const available = QUICK_CALCULATORS.filter(
		(calculator) => permissions?.[calculator.type],
	);

	if (available.length === 0) {
		return null;
	}

	const handleClick = (calculator: (typeof QUICK_CALCULATORS)[number]) => {
		if (wasDragged() || isOpeningCalculator) return;
		openCalculator(calculator.navigationType);
	};

	return (
		<Stack>
			<DashboardSectionHeader title={t(PageResources.title)} />
			<HorizontalScrollContainer
				scrollRef={scrollRef}
				onMouseDown={onMouseDown}
				pb={1.6}
				pl={1.6}
				gap={2}
				sx={{ cursor: "grab" }}
			>
				{available.map((calculator) => (
					<QuickCalculatorTile
						key={calculator.type}
						type={calculator.type}
						label={t(PageResources.Items[calculator.type])}
						variant={calculator.variant}
						onClick={() => handleClick(calculator)}
					/>
				))}
				<Box flexShrink={0} width={16} />
			</HorizontalScrollContainer>
		</Stack>
	);
};
